module.exports = __webpack_public_path__ + "media/images/writer/follow_up_mailer/video_2-7ec8834f03d4d9eac08eea47f57bab8b.png";